// extracted by css-extract-rspack-plugin
export default {"divider":"product-detail-fragment__Divider_divider__ctYtO"};